<template>
<div>
  <div class="ed-table__container" :class="{ 'table-no-action' : noAction }">
    <table class="ed-table" :id="tableId" :class="{ 'table-no-action' : noAction }">

      <ed-table-header
        :tableId="tableId"
        :tableBody="tableBody"
        :header="header"
        :headerSelectAll="trads.headerSelectAll"
        :headerSearchPlaceholder="trads.headerSearchPlaceholder"
        :actions="actions"
        :checkbox="checkbox"
        :resizable="resizable"
        :fixHeader="fixHeader"
        :noAction=noAction
        @clickSearchHeader="emitHeaderSearch"
        @clickCloseSearch="emitCloseSearchHeader"
        ref="header">
      </ed-table-header>

      <tbody :class="{ 'table-no-action' : noAction }">
        <tr v-if="!tableBody.length">
          <td :colspan="colsNumber" class="empty-results">
            {{ trads.noData }}
          </td>
        </tr>
        <tr v-for="(elmt, index) in tableBody" :id="'row_' + elmt.id">
          <td class="ed-table__cell ed-table__cell--checkbox" v-if="checkbox">
            <div class="ed-table__cell-content">
              <checkbox :id="`${tableId}${elmt.id}`" :ref="elmt.id" :value="elmt.id" @check="selectItem" @uncheck="unselectItem"></checkbox>
                <i class="icon-tag" v-if="tag"><tooltip direction="top" class="ed-table__tooltip"><span v-for="tag in elmt.tag" class="ed-table__tag">{{ tag }}</span></tooltip></i>
                <span style="position: fixed;" v-else></span>
            </div>
          </td>
          <td v-for="(item, itemIndex) in header" class="ed-table__cell" :data-columnName="item.reference" v-if="isShowedOnLoad(item.reference)"
            v-bind:style="{ paddingRight : (30 * columnHasAction(item.reference) + 10) + 'px' }" @click="(!noAction ? rowClickFunction(elmt) : null)">
            <div class="ed-table__cell-content">{{ formatData(elmt, item.reference) }}
              <span style="position: fixed;" v-if="itemIndex === 0 && !checkbox"></span>
              <span class="ed-table__infos-container" v-show="columnHasAction(item.reference)">
                <span class="ed-table__infos " v-for="action in actions" v-if="action.reference === item.reference" >
                  <adapt-button @click.native="action.function">
                    <span>{{ action.content }}</span>
                  </adapt-button>
                  <tooltip direction="top">{{ action.name }}</tooltip>
                </span>
              </span>
            </div>
            <div class="ed-table__borders" v-if="resizable"></div>
          </td>
          <td v-for="action in actions" class="ed-table__cell action-cell" v-if="!action.reference">
            <div class="ed-table__cell-content">
              <div class="action-container">
                <adapt-button @click.native="action.function(elmt)">
                  <span v-html="action.content"></span>
                </adapt-button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>


  <ed-table-footer
    :totalPages="totalPages"
    :totalElmtsFooter="totalElmts"
    :header="header"
    :footerTotalLabel="trads.footerTotalLabel"
    :footerModalOpen="trads.footerModalOpen"
    :footerModalTitle="trads.footerModalTitle"
    :footerModalAction="trads.footerModalAction"
    :footerPaginationLabel1="trads.footerPaginationLabel1"
    :footerPaginationLabel2="trads.footerPaginationLabel2"
    :footerPaginationSeparator="trads.footerPaginationSeparator"
    :currentParentPage="currentParentPage"
    :optionElmtByPage="optionElmtByPage"
    :elmtsByPage="currentParentElmtByPage"
    :hideShowColumns="hideColumns"
    @pageChange="newPage"
    @elementsNumberChange="newElementsNumber"
    @columnChange="columnChange"
    v-if="!noFooter">
  </ed-table-footer>

</div>
</template>

<script>
  import edTableHeader from './edTableHeader';
  import edTableFooter from './edTableFooter';

  export default {
    name: 'edTable',
    data() {
      return {
        selectedRows: [],
        actualCurrentPage: this.currentParentPage,
        actualElmtsByPage: this.$parent.$data[this.currentParentElmtByPage],
        colsNumber: '',
      };
    },
    components: {
      'ed-table-header': edTableHeader,
      'ed-table-footer': edTableFooter,
    },
    props: {
      tableId: {
        type: String,
        required: true,
      },
      selectedItems: {
        type: Array,
        required: false,
        default: () => [],
      },
      header: Array,
      tableBody: Array,
      actions: Array,
      checkbox: Boolean,
      tag: Boolean,
      trads: Object,
      resizable: Boolean,
      totalPages: Number,
      totalElmts: Number,
      currentParentPage: Number,
      optionElmtByPage: Array,
      currentParentElmtByPage: String,
      hideColumns: Boolean,
      fixHeader: Boolean,
      noAction: Boolean,
      noFooter: Boolean,
    },
    watch: {
      currentParentPage() {
        this.currentPage = this.currentParentPage;
      },
      selectedItems(value) {
        this.selectedRows = value;
      },

      selectedRows(value) {
        this.$nextTick(() => {
          // deselect all checkboxes
          for (let i = 0; i < this.tableBody.length; i += 1) {
            this.$refs[`${this.tableBody[i].id}`][0].currentCheck = false;
          }
          // select checkboxes passed via props
          for (let i = 0; i < value.length; i += 1) {
            if (this.$refs[`${value[i].id}`] && this.$refs[`${value[i].id}`][0]) {
              this.$refs[`${value[i].id}`][0].currentCheck = true;
            }
          }
          this.$emit('selectedChange', { array: value, id: this.tableId });
          this.gestionSelectAllCheckbox();
        });
      },

      tableBody() {
        this.$nextTick(() => {
          if (this.checkbox) {
            this.shiftSelectAction();
            const allCheckboxes = document.getElementsByClassName('ed-checkbox__input');
            for (let i = 1; i < allCheckboxes.length; i += 1) {
              if (this.selectedRows.findIndex(elmt => `${this.tableId}${elmt.id}` === allCheckboxes[i].id) > -1) {
                if (!allCheckboxes[i].checked) {
                  allCheckboxes[i].checked = true;
                }
              } else {
                if (allCheckboxes[i].checked) {
                  allCheckboxes[i].checked = false;
                }
              }
            }
            this.gestionSelectAllCheckbox();
          }
          if (this.resizable) {
            this.resizableColumns('ed-table__header--drag');
          }
        });
        this.cellsWidthEqualHeaderWidth();
      },
    },
    methods: {

      emitHeaderSearch(value) {
        this.$emit('headerSearch', value);
      },

      gestionSelectAllCheckbox() {
        let countdown = 0;
        for (let index = 0; index < this.tableBody.length; index += 1) {
          if (document.getElementById(`${this.tableId}${this.tableBody[index].id}`) &&
            document.getElementById(`${this.tableId}${this.tableBody[index].id}`).checked) {
            countdown += 1;
          }
        }
        if (this.tableBody.length > 0 && countdown === this.tableBody.length) {
          if (!this.$refs.header.$refs.headerCheckbox.currentCheck) {
            this.$refs.header.$refs.headerCheckbox.currentCheck = true;
          }
        } else if (this.$refs.header.$refs.headerCheckbox.currentCheck) {
          this.$refs.header.$refs.headerCheckbox.currentCheck = false
        }
      },

      /* *******************
       *** Body functions ***
       ******************* */

      /* Get the element attribute value even when it's an object's attribute */
      /* of an object's attribute of an object ... */
      formatData(elmt, targetAttribute) {
        const attrArray = targetAttribute.split('.');
        if (attrArray.length > 1) {
          let elmtArbo = elmt;
          for (let i = 0; i < attrArray.length; i += 1) {
            elmtArbo = elmtArbo[attrArray[i]];
          }
          return elmtArbo;
        }
        return elmt[targetAttribute];
      },

      selectItem(checkboxValue) {
        const index = this.tableBody.findIndex(elmt => elmt.id === checkboxValue);
        if (this.selectedRows.findIndex(elmt => elmt.id === this.tableBody[index].id) === -1) {
          this.selectedRows.push(this.tableBody[index]);
        }
      },

      unselectItem(checkboxValue) {
        const i = this.selectedRows.findIndex(elmt => elmt.id === checkboxValue);
        if (i !== -1) {
          this.selectedRows.splice(i, 1);
        }
      },

      isShowedOnLoad(columnName) {
        /* Get if the property show of the column was true or false at the beggining */
        /* Show the cell or not in consequences */
        const index = this.header.findIndex(elmt => elmt.reference === columnName);
        if (index > -1) {
          if (this.header[index].show) {
            return true;
          }
        }
        return false;
      },


      columnHasAction(columnName) {
        /* Return the number of actions associated with a particular column */
        /* in order to let space on the cells for these actions */
        let actionNumber = 0;
        if (this.actions) {
          for (let i = 0; i < this.actions.length; i += 1) {
            if (this.actions[i].reference === columnName) {
              actionNumber += 1;
            }
          }
        }
        return actionNumber;
      },

      shiftSelectAction() {
        /* Get all the checkbox/label containers from the table */
        const allCheckboxesBlock = document.getElementById(this.tableId).getElementsByClassName('ed-checkbox');
        for (let i = 1; i < allCheckboxesBlock.length; i += 1) {
          /* Add a click (mousedown) event to these containers */
          allCheckboxesBlock[i].addEventListener('mousedown', (event) => {
            this.shiftSelectFunction(event, i, allCheckboxesBlock);
          });
          if (this.selectedRows.findIndex(elmt => `${this.tableId}${elmt.id}` ===
            allCheckboxesBlock[i].getElementsByTagName('input')[0].id) > -1) {
            if (!allCheckboxesBlock[i].getElementsByTagName('input')[0].checked) {
              allCheckboxesBlock[i].getElementsByTagName('input')[0].click();
            }
          } else if (allCheckboxesBlock[i].getElementsByTagName('input')[0].checked) {
            allCheckboxesBlock[i].getElementsByTagName('input')[0].click();
          }
        }
      },

      /* Function triggered on checkbox container click */
      shiftSelectFunction(event, index, allCheckboxesBlock) {
        /* Get the last chekcbox that as been checked */
        /* It is the last one added to the v-model (selectedRows) */
        const indexLastChecked = this.tableBody.findIndex(el =>
          el === this.selectedRows[this.selectedRows.length - 1]);
        /* Hides the selection by adding a transparent background to it */
        document.getElementById(this.tableId).className += (' ed-transparent-selection');
        if (event.shiftKey && indexLastChecked !== undefined) {
          /* If we get a shift event : */
          if (indexLastChecked + 1 !== index) {
            /* Set the range start from the last checked index ... */
            let start = indexLastChecked + 1;
            /* ... to the index of the current checked checkbox */
            let end = index;
            if (end < start) {
              /* And conversely if the current index is highter than the other */
              end = start;
              start = index;
            }
            for (let range = start; range <= end; range += 1) {
              /* Set all checkbox in the range checked */
              if (!allCheckboxesBlock[range].getElementsByTagName('input')[0].checked) {
                allCheckboxesBlock[range].getElementsByTagName('input')[0].click();
              }
            }
          }
          document.onkeyup = () => {
            /* Edge workaround because it did not want to select last checkbox, for some reasons */
            if (!allCheckboxesBlock[index].getElementsByTagName('input')[0].checked) {
              allCheckboxesBlock[index].getElementsByTagName('input')[0].click();
            }
            /* This removes all text selection when you stop pressing the shift key. */
            window.getSelection().removeAllRanges();
            /* Removes the class on the table that allowed to hide the selection */
            document.getElementById(this.tableId).classList.remove('ed-transparent-selection');
          };
        } else {
          /* Removes the class on the table that allowed to hide the selection */
          // eslint-disable-next-line
          event.target.onmouseup = () => {
            document.getElementById(this.tableId).classList.remove('ed-transparent-selection');
          };
        }
      },

      resizableColumns(anchorClass) {
        /* Initialize the draggable object */
        let dragObj = null;
        /* Gets list of all anchors of the document by the given class name */
        const anchor = document.getElementsByClassName(anchorClass);
        /* Put all table headers that will be resized on a array */
        const allHeaders = [];
        for (let index = 0; index < document.getElementById(this.tableId).getElementsByTagName('th').length; index += 1) {
          if (document.getElementById(this.tableId).getElementsByTagName('th')[index].hasAttribute('data-columnname')) {
            allHeaders.push(document.getElementById(this.tableId).getElementsByTagName('th')[index]);
          }
        }
        const allCells = document.getElementById(this.tableId).getElementsByClassName('ed-table__cell');

        function draggable(obj) {
          const currentObj = obj;
          /* Sets the eventListener on the object */
          currentObj.onmousedown = () => {
            /* Updates the draggable object to the current object */
            /* from where the event has been triggered */
            dragObj = obj;
          };
        }

        /* Resets the draggable object to null so no event get triggered after mouseUp */
        document.onmouseup = () => {
          if (dragObj) {
            /* Reset the position of the anchor in function of its parent */
            dragObj.style.left = 'auto';
            dragObj.style.right = '0';
            dragObj = null;
            /* Fix width of headers when the event is over */
            for (let index = 0; index < allHeaders.length; index += 1) {
              allHeaders[index].style.width = `${allHeaders[index].offsetWidth -
                (parseInt(window.getComputedStyle(allHeaders[index]).paddingLeft, 10) +
                 parseInt(window.getComputedStyle(allHeaders[index]).paddingRight, 10))}px`;
            }
            this.cellsWidthEqualHeaderWidth();
          }
        };

        document.onmousemove = (e) => {
          /* Gets the actual horizontal axis of the pointer */
          const x = e.pageX;
          /* Gets the index of the draggabe object in the anchor list */
          const tableIndex = [].slice.call(anchor).indexOf(dragObj);

          /* Stops the movement of the object if its axis */
          /* is lower than its parent left axis */
          if (dragObj == null ||
            x <= (dragObj.parentNode.getBoundingClientRect().left + 8)) {
            return;
          }
          /* Stop the movement of the object if there is another anchor after it and */
          /* the axis of the current object is highter than its follower */
          if (anchor[tableIndex - 1]) {
            let i = tableIndex - 1;
            /* Jumps to the next anchor if this one is hidden */
            while (anchor[i] && anchor[i].parentNode.style.display === 'none') {
              i -= 1;
            }
            if (anchor[i] && x <= (anchor[i].getBoundingClientRect().left + 20)) {
              return;
            }
          }
          /* Stop the movement of the object if there is another anchor before it and */
          /* the axis of the current object is lower than the previous */
          if (anchor[tableIndex + 1]) {
            let i = tableIndex + 1;
            /* Jumps to the previous anchor if this one is hidden */
            while (anchor[i] && anchor[i].parentNode.style.display === 'none') {
              i += 1;
            }
            if (anchor[i] && x >= (anchor[i].getBoundingClientRect().left - 7)) {
              return;
            }
          }

          /* Keeps the previous left position */
          const prevLeft = dragObj.style.left;
          /* Sets the the new distance to the left of the draggable object */
          const nextLeft = `${x - dragObj.parentNode.getBoundingClientRect().left - (dragObj.offsetWidth / 2) - 2}px`;
          dragObj.style.left = nextLeft;
          /* Only places the object from its left distance */
          dragObj.style.right = 'auto';
          const columnName = dragObj.parentNode.getAttribute('data-columnName');
          let tableWidth = document.getElementsByTagName('table')[0].offsetWidth;
          let columnWidth = 0;
          /* Resize the header that contains the anchor and the next one */
          /* Make the next header anchor moves too as this header width changes */
          for (let index = 0; index < allHeaders.length; index += 1) {
            if (allHeaders[index].getAttribute('data-columnname') === columnName) {
              if (prevLeft.length && nextLeft.length) {
                columnWidth = parseInt(allHeaders[index].style.width, 10)
                  - (parseInt(prevLeft, 10)
                  - parseInt(nextLeft, 10));
                allHeaders[index].style.width = `${columnWidth}px`;
              }

              let i = tableIndex + 1;
              /* Jumps to the previous anchor if this one is hidden */
              while (anchor[i] && anchor[i].parentNode.style.display === 'none') {
                i += 1;
              }

              if (anchor[i]) {
                const targetedCells = [];
                for (let cellIndex = 0; cellIndex < allCells.length; cellIndex += 1) {
                  if (allCells[cellIndex].getAttribute('data-columnname') === anchor[i].parentNode.getAttribute('data-columnname')) {
                    targetedCells.push(allCells[cellIndex]);
                  }
                }
                if (parseInt(prevLeft, 10) > parseInt(nextLeft, 10)) {
                  /* Enlarge next header width */
                  anchor[i].parentNode.style.width =
                    `${parseInt(anchor[i].parentNode.style.width, 10) +
                    (parseInt(prevLeft, 10) - parseInt(nextLeft, 10))}px`;
                  for (let targetIndex = 0; targetIndex < targetedCells.length; targetIndex += 1) {
                    if (targetedCells[targetIndex].getElementsByClassName('ed-table__cell-content')[0]) {
                      targetedCells[targetIndex].getElementsByClassName('ed-table__cell-content')[0].style.width =
                        `${(parseInt(anchor[i].parentNode.style.width, 10) +
                        (parseInt(prevLeft, 10) - parseInt(nextLeft, 10))) - 5}px`;
                    }
                  }
                  /* Move next anchor */
                  anchor[i].style.left = `${parseInt(anchor[i].style.left, 10) +
                    (parseInt(prevLeft, 10) - parseInt(nextLeft, 10))}px`;
                } else if (parseInt(prevLeft, 10) < parseInt(nextLeft, 10)) {
                  /* Reduce next header width */
                  anchor[i].parentNode.style.width =
                    `${parseInt(anchor[i].parentNode.style.width, 10) -
                    (parseInt(nextLeft, 10) - parseInt(prevLeft, 10))}px`;
                  for (let targetIndex = 0; targetIndex < targetedCells.length; targetIndex += 1) {
                    if (targetedCells[targetIndex].getElementsByClassName('ed-table__cell-content')[0]) {
                      targetedCells[targetIndex].getElementsByClassName('ed-table__cell-content')[0].style.width =
                        `${parseInt(anchor[i].parentNode.style.width, 10) -
                        (parseInt(nextLeft, 10) - parseInt(prevLeft, 10)) - 5}px`;
                    }
                  }
                  /* Move next anchor */
                  anchor[i].style.left = `${parseInt(anchor[i].style.left, 10) -
                    (parseInt(nextLeft, 10) - parseInt(prevLeft, 10))}px`;
                }
              } else {
                if (parseInt(prevLeft, 10) > parseInt(nextLeft, 10)) {
                  tableWidth -= parseInt(prevLeft, 10) - parseInt(nextLeft, 10);
                } else if (parseInt(prevLeft, 10) < parseInt(nextLeft, 10)) {
                  tableWidth += parseInt(nextLeft, 10) - parseInt(prevLeft, 10);
                }
                document.getElementById(this.tableId).style.width = `${tableWidth}px`;
                document.getElementsByTagName('tbody')[0].style.width = `${tableWidth}px`;
              }
            }
          }
          if (prevLeft.length && nextLeft.length) {
            for (let cellIndex = 0; cellIndex < allCells.length; cellIndex += 1) {
              if (allCells[cellIndex].getAttribute('data-columnname') === columnName && allCells[cellIndex].getElementsByClassName('ed-table__cell-content')[0]) {
                allCells[cellIndex].getElementsByClassName('ed-table__cell-content')[0].style.width = `${columnWidth - 5}px`;
              }
            }
          }
          const fullHeaders = document.getElementsByTagName('tr')[0].getElementsByTagName('th');
          for (let fullIndex = 0; fullIndex < fullHeaders.length; fullIndex += 1) {
            tableWidth += fullHeaders[fullIndex].offsetWidth;
          }
        };

        /* Attributes the event listeners to anchor elements */
        for (let i = 0; i < anchor.length; i += 1) {
          draggable(anchor[i]);
        }
        /* Fix width of headers on load */
        for (let index = 0; index < allHeaders.length; index += 1) {
          allHeaders[index].style.width = `${allHeaders[index].offsetWidth -
            (parseInt(window.getComputedStyle(allHeaders[index]).paddingLeft, 10) +
             parseInt(window.getComputedStyle(allHeaders[index]).paddingRight, 10))}px`;
        }
        this.cellsWidthEqualHeaderWidth();
      },

      rowClickFunction(elmtId) {
        this.$emit('rowClick', elmtId);
      },

      setColsNumber() {
        if (document.getElementById(this.tableId).getElementsByTagName('tr')[0]) {
          const numberCol = document.getElementById(this.tableId).getElementsByTagName('tr')[0].getElementsByTagName('th').length;
          this.colsNumber = numberCol;
        }
      },

      emitCloseSearchHeader(value) {
        this.$emit('headerCloseSearch', value);
      },

      cellsWidthEqualHeaderWidth() {
        let table = document.getElementById(this.tableId);
        if (table) {
          let tableWidth = 0;
          const headerWidth = [];
          const headerCells = document.getElementById(this.tableId).getElementsByTagName('tr')[0].getElementsByClassName('ed-table__header');
          const rows = document.getElementById(this.tableId).getElementsByTagName('tr');
          for (let i = 0; i < headerCells.length; i += 1) {
            if (headerCells[i].offsetWidth && headerCells[i].offsetWidth > 0) {
              if (headerCells[i].style.width.length) {
                headerWidth.push(`${parseInt(headerCells[i].style.width, 10) - 5}px`);
              } else {
                headerWidth.push(`${headerCells[i].offsetWidth -
                  (parseInt(window.getComputedStyle(headerCells[i]).getPropertyValue('padding-left'), 10) +
                  parseInt(window.getComputedStyle(headerCells[i]).getPropertyValue('padding-right'), 10) + 5)}px`);
              }
              tableWidth += headerCells[i].offsetWidth;
            }
          }
          this.$nextTick(() => {
            for (let rowsIndex = 0; rowsIndex < rows.length; rowsIndex += 1) {
              const allInnerCells = rows[rowsIndex].getElementsByClassName('ed-table__cell');
              const innerCells = [];
              for (let index = 0; index < allInnerCells.length; index += 1) {
                if (allInnerCells[index].style.display !== 'none') {
                  innerCells.push(allInnerCells[index]);
                }
              }
              for (let innerIndex = 0; innerIndex < innerCells.length; innerIndex += 1) {
                if (innerCells[innerIndex].getElementsByClassName('ed-table__cell-content')[0]) {
                  innerCells[innerIndex].getElementsByClassName('ed-table__cell-content')[0].style.width = headerWidth[innerIndex];
                }
              }
            }
          });
          document.getElementById(this.tableId).style.width = `${tableWidth}px`;
          document.getElementById(this.tableId).getElementsByTagName('tbody')[0].style.width = `${tableWidth}px`;
        }
      },


      /* *******************
       ** Footer functions **
       ******************* */

      newPage(newValue) {
        this.actualCurrentPage = newValue;
        this.$emit('pageChange', this.actualCurrentPage);
      },

      newElementsNumber(newValue) {
        // this.$parent.$data[this.currentParentElmtByPage] = newValue;
        this.$emit('elementsNumberChange', newValue);
      },

      columnChange() {
        this.setColsNumber();
        if (this.resizable) {
          this.resizableColumns('ed-table__header--drag');
        }
      },

    },
    mounted() {
      if (this.checkbox) {
        this.selectedRows = this.selectedItems;
        this.shiftSelectAction();
      }
      if (this.resizable) {
        this.resizableColumns('ed-table__header--drag');
      } else {
        window.addEventListener('resize', () => {
          this.cellsWidthEqualHeaderWidth();
        });
      }
      this.cellsWidthEqualHeaderWidth();
      this.setColsNumber();
    },

  };
</script>



// WEBPACK FOOTER //
// edTable.vue?68c5a435